import { render, staticRenderFns } from "./IssueArticles.vue?vue&type=template&id=4659e3f0&scoped=true&"
import script from "./IssueArticles.vue?vue&type=script&lang=js&"
export * from "./IssueArticles.vue?vue&type=script&lang=js&"
import style0 from "./IssueArticles.vue?vue&type=style&index=0&id=4659e3f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4659e3f0",
  null
  
)

export default component.exports